import {useEffect} from 'react';

import Notification from '@/components/Notification';
import {getMorphoService, serviceNames} from '@/rte/editor';
import {feLogger, reportClickInsertSubDocList, reportShowInsertSubDocList} from '@/buried';
import {tipStorageObj} from '@/utils/document/common';

import styles from './index.module.scss';
import {EDITOR_MODE} from '@/Constant';
import toast, {ToastType} from '@/components/Toast';

interface IProps {
    onClose: () => void;
    mode: string;
    setIsInsertPreview: (val: boolean) => void;
    onSwitchEdit: () => void;
}

export function InsertEmbed(curMode: EDITOR_MODE) {
    const embedService = getMorphoService(serviceNames.IEmbedService);
    const isPreviewMode = curMode === EDITOR_MODE.preview;

    if (embedService && embedService.insertEmbed) {
        embedService.insertEmbed({
            type: 'subDocList',
            triggerType: isPreviewMode ? 'emptypage_view' : 'emptypage',
        });
    }
    toast({
        duration: 3000,
        type: ToastType.Success,
        content: '子文档列表卡插入成功',
    });
    const params = {from: isPreviewMode ? 'emptypage_view' : 'emptypage_edit'};
    feLogger(reportClickInsertSubDocList(params));
}

function EmptyParentNodeTip(props: IProps) {
    const {onClose, mode, setIsInsertPreview, onSwitchEdit} = props;
    const isPreviewMode = mode === EDITOR_MODE.preview;

    useEffect(() => {
        feLogger(reportShowInsertSubDocList({from: isPreviewMode ? 'emptypage_view' : 'emptypage_edit'}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        tipStorageObj.set();
        onClose();
    };

    const handlePreviewClick = () => {
        onSwitchEdit();
        setIsInsertPreview(true);
    };

    const handleEditClick = () => {
        InsertEmbed(EDITOR_MODE.edit);
        onClose();
    };

    return (
        <div className={styles.notification}>
            <Notification
                type={'info'}
                content={<span>
                    {isPreviewMode ? '' : '当前文档无内容，'}
                    可在文内插入子文档列表，轻松管理子页面，
                    <a onClick={isPreviewMode ? handlePreviewClick : handleEditClick}>
                        一键插入
                    </a>
                </span>}
                onClose={handleClose}
            />
        </div>
    );
}

export default EmptyParentNodeTip;
